import { render, staticRenderFns } from "./applyHistory.vue?vue&type=template&id=2ba1e211&scoped=true&lang=pug&"
import script from "./applyHistory.vue?vue&type=script&lang=js&"
export * from "./applyHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1e211",
  null
  
)

export default component.exports